export default __webpack_public_path__ + "static/media/img-4.4c2ecde7.jpg";